import { ReactNode } from "react";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import Icon3D from "./icon-3d";
import { Tone } from "./tones";

export default function EmptyState({ icon, tone = "slate", title, text, action }: { icon: IconDefinition; tone?: Tone; title: string; text: string; action?: ReactNode }) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 px-6 py-16 text-center">
      <Icon3D icon={icon} tone={tone} size="xl" flat className="animate-[rise-in_0.5s_ease-out_both]" />
      <p className="font-[Gilroy-Bold] text-[17px] text-heading-color">{title}</p>
      <p className="max-w-sm font-[Gilroy-Medium] text-[14px] text-light-gray">{text}</p>
      {action}
    </div>
  );
}
